
<template>
<b-container class="hero-section">
        <b-row>
          <b-col md="6" align-self="center">
            <h1>Timeless Leather</h1>
            <p>Quality leather products for every occasion. Crafted with care and attention to detail, for everyday use.</p>
            
          </b-col>

          <b-col md="6">
            <b-img 
            :src="products"
            alt="leather products" 
            class="img-fluid">
          </b-img>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12" align-self="center">
            <b-button variant="primary"><router-link to="/leather" class="btn-primary">Shop Now</router-link></b-button>
          </b-col>
        </b-row>
      </b-container>
      </template>
         
  <script>
import products from '../assets/products.jpg'

export default {
  data() {
    return {
      products
    }
  }
  
}
     </script>
        
       
        
  <style>
   /*Hero Section*/

    .hero-section {
        padding-top: 50px;
        background-color: #f5e5e6;
        padding-bottom: 50px;
      }

    .hero-section h1 {
        font-size: 48px;
        font-weight: 700;
        color: #303030;
        margin-bottom: 25px;
      }

      .hero-section p {
        font-size: 18px;
        color: #303030;
        margin-bottom: 35px;
      }

      .hero-section .btn-primary {
        background-color: #b65f4a;
        border-color: #b65f4a;
        text-decoration: none;
        color: #ffffff;
      }

      .hero-section .btn-primary:hover {
        background-color: #303030;
        border-color: #303030;
      }

      .btn-primary .router-link {
        color: #ffffff;
        text-decoration: none;
      }

      .btn-primary:active .router-link {
        color: #ffffff;
        text-decoration: none;
      }

      .hero-section .img-fluid {
        width: 90%;
        height: 300px;
        object-fit: cover;
        border-radius: 10px;
      }

  </style>